import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

export enum LocationType {
	serviceSiteLocation = 1,
	supplierLocation = 0
}

export enum MapsFilterFields {
	facilityTypeId = 'facilityTypeId',
	displayServiceSites = 'displayServiceSites',
	displaySupplierLocations = 'displaySupplierLocations',
	radius = 'radius'
}

export enum MapsFacilitySearchFields {
	states = 'states'
}

export enum MapsMainSearchFields {
	searchByServiceSiteId = 'searchByServiceSiteId',
	searchByServiceSiteName = 'searchByServiceSiteName',
	searchBySupplierLocationId = 'searchBySupplierLocationId',
	searchBySupplierLocationName = 'searchBySupplierLocationName'
}

export enum MapsSingleSearchApiFields {
	service = 'service',
	supplier = 'supplier'
}

export enum SupplierLocationStatus {
	inProcess = 'in process',
	approved = 'approved',
	approvedWithRestriction = 'Approved with Restriction',
	denied = 'denied',
	restricted = 'restricted',
	approvedFranchised = 'approved - franchised',
	restrictedImplementation = 'restricted - implementation',
	restrictedIndemnityLtr = 'restricted-indemnity ltr',
	restrictedIndemnityContract = 'restricted-indemnity Contract'
}

export enum ServiceSiteLocationStatus {
	active = 'active',
	new = 'new'
}

export enum LocationMapAddressType {
	supplier = 1,
	serviceSite = 2,
	all = 3
}

export declare namespace Maps {
	interface Contact extends Entity {
		lastName: string
	}

	interface LocationAddress {
		addressLine1: string
		cityName: string
		postalCode: string
		stateProvince: string
		stateProvinceId: number
		latitude: number
		longitude: number
	}

	interface AddressItem {
		id: number
		name: string
		locationAddressMapItemType: number
		distanceToPoint: number
		status: Entity
		companyId: number
		companyName: string
		contacts: Contact[]
		locationAddress: LocationAddress
		locationType: LocationType
		isInActive: boolean
	}

	interface OmitedAddressItem {
		id: number
		locationAddressMapItemType: number
		status: string
		latitude: number
		longitude: number
		isInActive: boolean
	}

	interface LocationResponse {
		supplierLocationAddressMapItems: OmitedAddressItem[] | null
		serviceSiteAddressMapItems: OmitedAddressItem[] | null
	}

	interface SingleSearchBasic {
		id: number
		name: string
		locationAddressMapItemType: number
		distanceToPoint: number
		status: Entity
		locationAddress: LocationAddress
		isInActive: boolean
	}

	interface Basic extends OmitedAddressItem {}

	interface UrlParams {
		key: string
		value: string
	}

	namespace Filter {
		interface Config {
			[MapsFilterFields.facilityTypeId]: ConfigFilterItem<string, null>
			[MapsFilterFields.displayServiceSites]: ConfigFilterItem<string, boolean>
			[MapsFilterFields.displaySupplierLocations]: ConfigFilterItem<string, boolean>
			[MapsFilterFields.radius]: ConfigFilterItem<string, null>
		}
	}

	namespace Search {
		namespace FacilitySearch {
			interface Result {
				[MapsFacilitySearchFields.states]: Entity[]
			}

			interface Config {
				[MapsFacilitySearchFields.states]: ConfigItem<MapsFacilitySearchFields>
			}
		}
		namespace MainSearch {
			interface Result {
				[MapsMainSearchFields.searchByServiceSiteId]: Entity[]
				[MapsMainSearchFields.searchByServiceSiteName]: Entity[]
				[MapsMainSearchFields.searchBySupplierLocationId]: Entity[]
				[MapsMainSearchFields.searchBySupplierLocationName]: Entity[]
			}

			interface Config {
				[MapsMainSearchFields.searchByServiceSiteId]: ConfigItem<MapsMainSearchFields>
				[MapsMainSearchFields.searchByServiceSiteName]: ConfigItem<MapsMainSearchFields>
				[MapsMainSearchFields.searchBySupplierLocationId]: ConfigItem<MapsMainSearchFields>
				[MapsMainSearchFields.searchBySupplierLocationName]: ConfigItem<MapsMainSearchFields>
			}
		}
	}
}
